// TODO Provjeri imaju li ove funkcije ikakvu svrhu. Ako da, provjeri u historyu gdje smo ih uklonili pa revertaj izmjene.
export function modalDidMount () {
    if (document && document.body) {
        let orig = document.body.className;
        document.body.className = orig + (orig ? ' ' : '') + 'modal-open';
    }
}

export function modalWillUnmount () {
    if (document && document.body) {
        document.body.className = document.body.className.replace(/ ?modal-open/, '');
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/ModalFixMixin.js
 **/